export const config={
app:{
    host:"https://bonbon.slagerijwittepaleis.nl",
    port: 3000
},
api:{
    host:"https://bonbon.slagerijwittepaleis.nl/api",
    port: 3000
},
kvk:{
    host:"https://bonbon.slagerijwittepaleis.nl/kvk",
    port: 3000
},
payments:{
    host:"https://bonbon.slagerijwittepaleis.nl/payments",
    port: 3000
},
ws:{
    host:"wss://bonbon.slagerijwittepaleis.nl/ws",
    port: 3001
},
webpack: {
    host: "http://localhost:8080",
    port: 8080
},
snelstart:{
    host:"https://bonbon.slagerijwittepaleis.nl/snelstart",
    port: 3001
},
token: "AIzaSyCdYmiOMYeEl-35AJeu5s12jEHbuVofhQU"
}
